import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Icon, Progress } from "~/components-shared";
import styled from "styled-components";
import InputTextControl from "~/components/InputTextControl";
import lists from "~/lib/lists";
import { PasswordStrengthEnum } from "~/types/enums";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const SignUpMemberForm = _ref => {
  let {
    control,
    watch
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [securityLevel, setSecurityLevel] = useState(0);
  const [securityColor, setSecurityColor] = useState("transparent");
  const password = watch("password");
  useEffect(() => {
    if (lists.auth.password.regexp[PasswordStrengthEnum.STRONG].test(password)) {
      setSecurityLevel(100);
      setSecurityColor("success");
    } else if (lists.auth.password.regexp[PasswordStrengthEnum.MEDIUM].test(password)) {
      setSecurityLevel(66);
      setSecurityColor("warning");
    } else if (password.length) {
      setSecurityLevel(33);
      setSecurityColor("danger");
    } else {
      setSecurityLevel(0);
      setSecurityColor("transparent");
    }
  }, [password]);
  const handleShowPassword = () => {
    setShowPassword(prev => !prev);
  };
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 4,
    s: {
      mb: 4
    }
  }, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "firstName",
    label: t("SignUpMemberForm.firstName"),
    control: control
  }), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "lastName",
    label: t("SignUpMemberForm.lastName"),
    control: control
  })), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "password",
    label: t("SignUpMemberForm.password"),
    s: {
      mb: 2
    },
    type: showPassword ? "text" : "password",
    control: control,
    required: true,
    elemAfter: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      color: "transparent",
      s: {
        p: 1,
        mr: 1
      },
      outline: false,
      rounded: true,
      onClick: handleShowPassword
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "eye",
      scale: 5,
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("SignUpMemberForm.showPassword")
    })), /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      src: "infoOutline",
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-html": t("common.password.requirements")
    }))
  }), /*#__PURE__*/React.createElement(Progress, {
    values: [securityLevel],
    colors: [securityColor],
    height: 2,
    s: {
      mb: 3,
      mx: 1
    }
  }), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "repeatPassword",
    label: t("SignUpMemberForm.repeatPassword"),
    s: {
      mb: 2
    },
    type: "password",
    control: control,
    required: true
  }));
};
export default SignUpMemberForm;